import lodash from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { Col } from 'antd';
import Table from '../../../../../components/table/Table';

const tableCols = [
    { content: 'From', align: 'center' },
    { content: 'To', align: 'center' },
    { content: 'Note', align: 'center' },
];

class BikeFaultNotes extends React.Component {
    render() {
        const { data } = this.props;
        const dataExists = lodash.isArray(data) && !lodash.isEmpty(data);
        return (
            !dataExists
                ? null
                : (
                    <Col span={24}>
                        <div className="profile__information existingStock" style={{ marginLeft: -15, width: '98%' }}>
                            <div className="profile__data valuation">
                                <h3>Bike Fault Notes</h3>
                                <div className="tableWrapper">
                                    <div className="profile__contact">
                                        <Table>
                                            <thead>
                                                <tr>
                                                    {
                                                        tableCols.map((item, idx) => <th key={idx} className="tableHeader">{item.content}</th>)
                                                    }
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    data.map(item => (
                                                        <tr key={item._id}>
                                                            <td align={tableCols[0].align}>
                                                                <span>{item.year_from}</span>
                                                            </td>
                                                            <td align={tableCols[1].align}>
                                                                <span>{item.year_to}</span>
                                                            </td>
                                                            <td align={tableCols[2].align}>
                                                                <span>{item.note}</span>
                                                            </td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>
                )
        );
    }
}

const mapStateToProps = (state) => {
    const { bike_details } = state.Leads.Lead_profile.Ref_bike_lead;
    const modelKnowledge = lodash.get(bike_details, 'ref_bike_model.knowledge');

    return {
        data: modelKnowledge,
    };
};

export default connect(mapStateToProps)(BikeFaultNotes);



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Lead_profile_table/BikeFaultNotes.js